
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { defineComponent, onMounted, reactive } from 'vue'
import { useRoute } from 'vue-router'
import { UserInfo, UserService } from '@/services/user.service'
import { PayService } from '../pay.service'
import { openWxLogin } from '@/services/wechat/wxOauth.service'

export default defineComponent({
  setup() {
    const injector = useReflectiveInjector([PayService])
    const payService = injector.get(PayService)
    const userService = injector.get(UserService)

    const route = useRoute()
    const { unique_code, product_id } = route.query

    const viewModel = reactive({
      unique_code,
      product_id,
      open_id: '',
      keniu_token: '',
      hasUseOffer: false
    })

     const userHandle = reactive({
      userInfo: reactive<Partial<UserInfo>>({}),
      userInfoSub: null,
      subscribe: () => {
        userHandle.userInfoSub = userService.userInfo.subscribe((info) => {
          viewModel.open_id = info.openid
          viewModel.keniu_token = info.keniu_token
        })
      },
      unsubscribe: () => {
        userHandle.userInfoSub.unsubscribe()
      }
    })
    userHandle.subscribe()

    async function handleTouristLogin () {
      try {
        await userService.getApiPayloginLoginKeniu({
          code: unique_code as string,
          token: viewModel.keniu_token,
          keniu_product_id: '104'
        })
      } catch (error) {
        viewModel.hasUseOffer = true
      }
    }

    async function handlePay () {
      try {
        const productId = await payService.getApiRechargePrepare({
          biztype: 1,
          paytype: 1,
          id: Number(product_id),
          source: ''
        }).then(res => res.product_id)

        const order = await payService.palceWxPayOrder({
          payapp: 'keniuoffice',
          product_id: productId,
          openid: viewModel.open_id
        })

        // 根据下单返回的微信配置调起微信支付
        const wxPayConfig = order.wx_resp
        const orderId = order.order_id
        const fee = order.fee
        const paramsShowPay = {
          appId: wxPayConfig.appid,
          timeStamp: wxPayConfig.timestamp,
          nonceStr: wxPayConfig.noncestr,
          package: wxPayConfig.package,
          signType: wxPayConfig.sign_type,
          paySign: wxPayConfig.sign
        }
        payService.showWxPay(paramsShowPay, () => {
          payService.reportPay({
            actiontype: 'ykpay',
            ext: 'yk',
            uid: userHandle.userInfo.uid,
          })
          console.log('支付成功:', orderId, fee)
          // @ts-ignore
          WeixinJSBridge.call('closeWindow')
        })
      } catch (error) {
        viewModel.hasUseOffer = true
      }
    }

    onMounted(async () => {
      payService.reportPay({
        actiontype: 'ykshow',
        ext: 'yk',
        uid: userHandle.userInfo.uid,
      })
      if (viewModel.open_id && viewModel.keniu_token) {
        await handleTouristLogin()
        await handlePay()
      } else {
        payService.reportPay({
          actiontype: 'yklogin',
          ext: 'yk',
          uid: userHandle.userInfo.uid,
        })
        openWxLogin()
      }
    })

    return {
      ...viewModel
    }
  }
})
